import React from "react";
import GradeForm, {types} from "./GradeForm";
import { Paper, withStyles, Grid } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/gradeActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const GradeCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateGrade } = props;

    const handleSubmit = async data => {
        data["CustomerID"] === "system" ? data["CustomerID"] = null    :   data["CustomerID"] = activeCustomerID;
        let result = await onCreateGrade({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Condition: "",
        InternationalGrading: "",
        CustomerID: types && types.length > 0 ? types[0].value : ''
    };

    let formSettings = {
        Validation: {
            Condition: Yup.string().required("Required"),
            InternationalGrading: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required")
        },
        FormTitle: translations["create_grade"] || "Create grade",
        ButtonSubmit: hasPermission(permissions, "grade_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <GradeForm
                        classes={classes}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                        permissions={permissions}
                        CustomerIDPreviousState={''}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateGrade: grade => dispatch(actions.createGrade(grade))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(GradeCreate));